module.exports = __webpack_public_path__ + "static/media/DIN-Condensed-Bold.ff7403e5.eot";